
            const data = {"name":"glyph/16/condense","data":{"width":"16","height":"16","viewBox":"0 0 16 16","data":"<path pid=\"0\" d=\"m20 5.1-4.3 4.3 2.7 2.7H12V5.6l2.7 2.7L18.9 4ZM5.1 20l4.3-4.3 2.7 2.7V12H5.6l2.7 2.7L4 18.9Z\" transform=\"translate(-4 -4)\" _fill=\"#272c33\"/>","originalColors":[{"type":"fill","color":"#272c33"}],"stopColors":[]}}
        
                    module.exports = data
                    